import React, { useState } from 'react';

import { API } from 'constants';
import client from '../../../services/library-api';

import { mutateAllCachedRequest } from '../../../helpers/swrMutateUtils';

import { useSwrRequestKeysToMutateFromContext } from '../../../hooks/useSwrRequestKeysToMutateFromContext';

import { defaultErrorMessage } from '../../../constants/errorMessages';

import ConfirmDeletionModalPattern from '../../../design-system/ConfirmDeletionModalPattern/ConfirmDeletionModalPattern';

const DeleteScenarioModal = ({ id, name, onScenarioDelete, onClose }) => {
    const {
        requestKeysToMutate: { scenarios: requestKeysToMutate },
    } = useSwrRequestKeysToMutateFromContext();

    const [isLoading, setIsLoading] = useState(false);
    const [errorAlert, setErrorAlert] = useState(null);

    const handleDelete = async () => {
        try {
            setIsLoading(true);
            await client.delete(`${API.ROUTES.library.scenario}${id}/`);

            onScenarioDelete && onScenarioDelete();

            mutateAllCachedRequest({ requestKeysToMutate });

            onClose();
        } catch (e) {
            setIsLoading(false);
            setErrorAlert({ message: defaultErrorMessage, statusCode: e.response?.status });
        }
    };

    return (
        <ConfirmDeletionModalPattern
            title="Delete Scenario?"
            handleDelete={handleDelete}
            onClose={onClose}
            isLoading={isLoading}
            confirmationTextStart="You are about to delete"
            confirmationTextEnd="are you sure you’d like to continue? This will remove the Scenario from its Playbook."
            entityName={`${name},`}
            variant="secondary"
            errorAlert={errorAlert}
            setErrorAlert={setErrorAlert}
            buttonsSize="md"
        />
    );
};

export default DeleteScenarioModal;
